import { BookOpen, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { BASE_PATH } from '../api.ts';
import { PageHeader, Panel } from '../components/ui.tsx';

/**
 * Ajuda (rodapé da lateral, ao lado de Sair). Por enquanto, os guias do time: links para as páginas estáticas em `apps/web/public/guias/` (como configurar
 * GitHub e Claude Code e o que o administrador faz). Elas abrem sem login, para o link ir direto a
 * quem ainda não tem acesso ao sistema.
 */
const GUIDES = [
  { id: 'team', file: 'pessoa-convidada.html' },
  { id: 'admin', file: 'administrador.html' },
] as const;

export function HelpPage() {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader title={t('help.title')} description={t('help.description')} />
      <h2 className="text-base font-semibold">{t('guides.title')}</h2>
      <div className="grid gap-4 md:grid-cols-2">
        {GUIDES.map((g) => {
          const href = `${BASE_PATH}/guias/${g.file}`;
          return (
            <Panel key={g.id} title={t(`guides.${g.id}.title`)}>
              <p className="text-sm text-muted">{t(`guides.${g.id}.text`)}</p>
              <div className="flex flex-wrap items-center gap-3 text-sm">
                <a
                  href={href}
                  target="_blank"
                  rel="noopener"
                  className="inline-flex items-center gap-1.5 font-medium text-brand-text hover:underline"
                >
                  <BookOpen size={16} aria-hidden />
                  {t('guides.open')}
                  <ExternalLink size={14} aria-hidden />
                </a>
                <span className="font-mono text-xs break-all text-muted">
                  {window.location.origin}
                  {href}
                </span>
              </div>
            </Panel>
          );
        })}
      </div>
    </>
  );
}
